const PREFIXES = {
  B: { min: 0, max: 1024 },
  KB: { min: 1024, max: 1048576 },
  MB: { min: 1048576, max: 1073741824 },
  GB: { min: 1073741824, max: Number.MAX_VALUE },
}
export function getFileSizeWithPrefix(sizeBytes: number): string {
  const result = Object.entries(PREFIXES).find(
    ([_prefix, range]) => sizeBytes > range.min && sizeBytes <= range.max
  )

  if (result == null) {
    return String(sizeBytes)
  }

  const [prefix, range] = result

  if (prefix === 'B') {
    return `${sizeBytes} B`
  }

  const size = Math.ceil(sizeBytes / range.min)

  return `${size} ${prefix}`
}
